import React from "react";
import { Container1, Container2, Container3, Design1, TextBox, TextBox2, Wrapper } from "./style";
const Com4 = () => {
  return (
    <Wrapper>
      <Container1>
        <img loading="lazy" src="/assets/img/AffilicateCreator_3.png" alt="phoneImg" />
      </Container1>

      <Container3>
        <TextBox>
          <div>Step. 03</div>
          <div>
            <span>{"Creator 활동하기"}</span>
          </div>
          <div>
            <span>
              {"S-Store에 가입하셨나요! 가입 직후 가승인 상태로 바로 S-Store의 Creator로 활동할 수 있습니다."}
            </span>
            <span>{" 온,오프라인을 통해 Creator의 상품을 Sketch Wallet을 통해 결제 받으세요!"}</span>
          </div>
        </TextBox>
      </Container3>
      <Design1></Design1>
    </Wrapper>
  );
};

export default Com4;
